import { Button, Drawer, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  VENDOR_CREATE_CURTAIN,
  VENDOR_CREATE_DDK,
  VENDOR_CREATE_DND,
  VENDOR_CREATE_DOOR_CAMERA,
  VENDOR_CREATE_DOOR_LOCK,
  VENDOR_CREATE_LIGHT,
  VENDOR_CREATE_MMR,
  VENDOR_CREATE_SCENE,
  VENDOR_CREATE_THERMO,
  VENDOR_EDIT_CURTAIN,
  VENDOR_EDIT_DDK,
  VENDOR_EDIT_DND,
  VENDOR_EDIT_DOOR_CAMERA,
  VENDOR_EDIT_DOOR_LOCK,
  VENDOR_EDIT_LIGHT,
  VENDOR_EDIT_MMR,
  VENDOR_EDIT_SCENE,
  VENDOR_EDIT_THERMO,
  VENDOR_TAB_CURTAIN,
  VENDOR_TAB_DDK,
  VENDOR_TAB_DND,
  VENDOR_TAB_DOOR_CAMERA,
  VENDOR_TAB_DOOR_LOCK,
  VENDOR_TAB_LIGHT,
  VENDOR_TAB_MMR,
  VENDOR_TAB_SCENE,
  VENDOR_TAB_THERMO,
  VENDOR_VIEW_CURTAIN,
  VENDOR_VIEW_DDK,
  VENDOR_VIEW_DND,
  VENDOR_VIEW_DOOR_CAMERA,
  VENDOR_VIEW_DOOR_LOCK,
  VENDOR_VIEW_LIGHT,
  VENDOR_VIEW_MMR,
  VENDOR_VIEW_SCENE,
  VENDOR_VIEW_THERMO,
} from '../../../constants/VendorConst';
import { validateUserSession } from '../../../utils/authUtils';
import { getAllVendors } from '../../../utils/IntegrationsAPIUtils';
import { selectedHotelSelector } from '../../property/propertySlice';
import { fetchGRETemplates } from '../configurationSlice';
import VendorCreate from './shared/vendor-create/VendorCreate';
import VendorList from './shared/vendor-list/VendorList';
import VendorView from './shared/vendor-view/VendorView';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    minWidth: '98px',
    fontWeight: 500,
  },
  button: {
    borderRadius: '26px',
    minWidth: '98px',
    fontWeight: 500,
  },
  input: {
    display: 'none',
  },
}));

const VendorConfigs = (props) => {
  const { showLoader = () => {} } = props;
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(VENDOR_TAB_LIGHT);
  const [state, setState] = useState({ type: null, status: false, obj: null });
  const selectedHotel = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();
  const history = useHistory();

  const [viewState, setViewState] = useState({
    type: '',
    status: false,
    obj: null,
  });
  const [allVendors, setAllVendors] = useState({
    lights: [],
    thermostats: [],
    curtains: [],
    ddks: [],
    doorLock: [],
    doorCamera: [],
    DND: [],
    MMR: [],
  });

  const fetchAllVendors = () => {
    selectedHotel !== '' &&
      getAllVendors(selectedHotel)
        .then((res) => {
          setAllVendors(res?.data?.GetCategorizeVendors);
        })
        .catch((e) => {
          console.error(e);
        });
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  useEffect(() => {
    if (selectedHotel) {
      fetchAllVendors();
      dispatch(fetchGRETemplates(selectedHotel));
    }
  }, [history, selectedHotel]);

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case VENDOR_CREATE_LIGHT:
        return (
          <VendorCreate
            type={VENDOR_CREATE_LIGHT}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_LIGHT:
        return (
          <VendorCreate
            type={VENDOR_EDIT_LIGHT}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_SCENE:
        return (
          <VendorCreate
            type={VENDOR_CREATE_SCENE}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_SCENE:
        return (
          <VendorCreate
            type={VENDOR_EDIT_SCENE}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_CURTAIN:
        return (
          <VendorCreate
            type={VENDOR_CREATE_CURTAIN}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_CURTAIN:
        return (
          <VendorCreate
            type={VENDOR_EDIT_CURTAIN}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_THERMO:
        return (
          <VendorCreate
            type={VENDOR_CREATE_THERMO}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_THERMO:
        return (
          <VendorCreate
            type={VENDOR_EDIT_THERMO}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_DDK:
        return (
          <VendorCreate
            type={VENDOR_CREATE_DDK}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_DDK:
        return (
          <VendorCreate
            type={VENDOR_EDIT_DDK}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_DOOR_LOCK:
        return (
          <VendorCreate
            type={VENDOR_CREATE_DOOR_LOCK}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_DOOR_LOCK:
        return (
          <VendorCreate
            type={VENDOR_EDIT_DOOR_LOCK}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_DOOR_CAMERA:
        return (
          <VendorCreate
            type={VENDOR_CREATE_DOOR_CAMERA}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_DOOR_CAMERA:
        return (
          <VendorCreate
            type={VENDOR_EDIT_DOOR_CAMERA}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_DND:
        return (
          <VendorCreate
            type={VENDOR_CREATE_DND}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_DND:
        return (
          <VendorCreate
            type={VENDOR_EDIT_DND}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_CREATE_MMR:
        return (
          <VendorCreate
            type={VENDOR_CREATE_MMR}
            toggleDrawer={onDrawerToggle}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case VENDOR_EDIT_MMR:
        return (
          <VendorCreate
            type={VENDOR_EDIT_MMR}
            toggleDrawer={onDrawerToggle}
            data={state.obj}
            refreshVendors={fetchAllVendors}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inputState) => {
    switch (inputState.type) {
      case VENDOR_VIEW_LIGHT:
        return (
          <VendorView
            type={VENDOR_VIEW_LIGHT}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.lights}
          />
        );
      case VENDOR_VIEW_SCENE:
        return (
          <VendorView
            type={VENDOR_VIEW_SCENE}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.scenes}
          />
        );
      case VENDOR_VIEW_CURTAIN:
        return (
          <VendorView
            type={VENDOR_VIEW_CURTAIN}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.curtains}
          />
        );
      case VENDOR_VIEW_THERMO:
        return (
          <VendorView
            type={VENDOR_VIEW_THERMO}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.thermostats}
          />
        );
      case VENDOR_VIEW_DDK:
        return (
          <VendorView
            type={VENDOR_VIEW_DDK}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.ddks}
          />
        );
      case VENDOR_VIEW_DOOR_LOCK:
        return (
          <VendorView
            type={VENDOR_VIEW_DOOR_LOCK}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.doorLock}
          />
        );
      case VENDOR_VIEW_DOOR_CAMERA:
        return (
          <VendorView
            type={VENDOR_VIEW_DOOR_CAMERA}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.doorCamera}
          />
        );
      case VENDOR_VIEW_DND:
        return (
          <VendorView
            type={VENDOR_VIEW_DND}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.DND}
          />
        );
      case VENDOR_VIEW_MMR:
        return (
          <VendorView
            type={VENDOR_VIEW_MMR}
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            data={inputState.obj}
            hotelId={selectedHotel}
            allVendors={allVendors.MMR}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {selectedHotel && viewState.status && <>{switchViewContent(viewState)}</>}
      {selectedHotel && !viewState.status && (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Vendors</span>
            </div>
          </div>
          <div className='row d-flex mt-4'>
            <div className='d-flex gap-3 flex-wrap'>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_LIGHT ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_LIGHT ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_LIGHT)}
              >
                Lights
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_SCENE ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_SCENE ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_SCENE)}
              >
                Scenes
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_CURTAIN ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_CURTAIN ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_CURTAIN)}
              >
                Curtains
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_THERMO ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_THERMO ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_THERMO)}
              >
                Thermostat
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_DDK ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_DDK ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_DDK)}
              >
                Digital Door Key
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_DOOR_LOCK ? 'outlined' : 'text'}
                className={
                  activeTab === VENDOR_TAB_DOOR_LOCK ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(VENDOR_TAB_DOOR_LOCK)}
              >
                Door Lock
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_DOOR_CAMERA ? 'outlined' : 'text'}
                className={
                  activeTab === VENDOR_TAB_DOOR_CAMERA ? classes.activeButton : classes.button
                }
                onClick={() => setActiveTab(VENDOR_TAB_DOOR_CAMERA)}
              >
                Door Camera
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_DND ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_DND ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_DND)}
              >
                DND
              </Button>
              <Button
                size='large'
                variant={activeTab === VENDOR_TAB_MMR ? 'outlined' : 'text'}
                className={activeTab === VENDOR_TAB_MMR ? classes.activeButton : classes.button}
                onClick={() => setActiveTab(VENDOR_TAB_MMR)}
              >
                MMR
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === VENDOR_TAB_LIGHT && (
                <VendorList
                  type={VENDOR_TAB_LIGHT}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.lights}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_SCENE && (
                <VendorList
                  type={VENDOR_TAB_SCENE}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.scenes}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_CURTAIN && (
                <VendorList
                  type={VENDOR_TAB_CURTAIN}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.curtains}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_THERMO && (
                <VendorList
                  type={VENDOR_TAB_THERMO}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.thermostats}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_DDK && (
                <VendorList
                  type={VENDOR_TAB_DDK}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.ddks}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_DOOR_LOCK && (
                <VendorList
                  type={VENDOR_TAB_DOOR_LOCK}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.doorLock}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_DOOR_CAMERA && (
                <VendorList
                  type={VENDOR_TAB_DOOR_CAMERA}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.doorCamera}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_DND && (
                <VendorList
                  type={VENDOR_TAB_DND}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.DND}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
              {activeTab === VENDOR_TAB_MMR && (
                <VendorList
                  type={VENDOR_TAB_MMR}
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  vendorList={allVendors?.MMR}
                  refreshVendors={fetchAllVendors}
                  hotelId={selectedHotel}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorConfigs;
